import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';

@Component({
  selector: 'app-incomes-second-headline',
  templateUrl: './incomes-second-headline.component.html',
  styleUrls: ['./incomes-second-headline.component.scss'],
})
export class IncomesSecondHeadlineComponent implements OnInit {
  listIncomesSecondLine: any;
  formGroup: FormGroup;
  has_income: boolean;
  constructor(
    public copyService: CopyService,
    private formBuilder: FormBuilder,
    private headerService: HeaderService,
    private navigationService: NavigationService,
    private bitacoraService: BitacoraService,
    private abreCuentasService: AbreCuentasService,
  ) {
    this.headerService.show(true, true, true);
    this.formGroup = this.formBuilder.group({});
  }

  ngOnInit() {
    const has_income = this.abreCuentasService.getSecondHeadline().has_incomes_second_headline;
    this.formGroup = new FormGroup({
      selection_incomes_second_headline: new FormControl('', Validators.required),
    });
    this.listIncomesSecondLine = [{
      label: this.copyService.copies.incomes_second_headline.second_yes,
      value: true,
      checked: has_income,
    },
    {
      label: this.copyService.copies.incomes_second_headline.second_no,
      value: false,
      checked: has_income === null ? false : !has_income,
    }];
  }

  next() {
    const has_second_headline = this.abreCuentasService.getSecondHeadline().has_second_headline;
    const value_income = this.formGroup.controls.selection_incomes_second_headline.value;
    this.abreCuentasService.setSecondHeadline({
      has_second_headline,
      has_incomes_second_headline: value_income,
    });
    const bitacoraEvent = `add Income_${ value_income ? 'yes' : 'no' }`;
    this.bitacoraService.saveDataInBitacora(bitacoraEvent);
    this.abreCuentasService.getSecondHeadline();
    this.navigationService.nextStep('200');
  }
}
